const meta = {
  module: "universities",
};

export default [
  {
    path: `/universities`,
    redirect: "/universities/page/1",
  },
  {
    path: `/universities/page`,
    redirect: "/universities/page/1",
  },
  {
    path: `/universities/page/:page`,
    name: "universities",
    component: () =>
      import(
        /* webpackChunkName: "universities" */ "@/modules/universities/views/index.vue"
      ),
    meta: {
      ...meta,
    },
  },
  {
    path: `/universities/create`,
    name: "universities/create",
    component: () =>
      import(
        /* webpackChunkName: "universities/create" */ "@/modules/universities/views/create.vue"
      ),
    meta: {
      ...meta,
      action: "create",
    },
  },
  {
    path: `/universities/edit/:id`,
    name: "universities/edit",
    component: () =>
      import(
        /* webpackChunkName: "universities/edit" */ "@/modules/universities/views/edit.vue"
      ),
    meta: {
      ...meta,
      action: "edit",
    },
  },
];
